import { OrderFilterPage } from "./orderFilter/OrderFilterPage";
import { OrderTablePage } from "./orderTable/OrderTablePage";

import classes from "./orderListPage.module.css";

export const OrderListPage = () => {
  return (
    <div className={classes.box}>
      <OrderFilterPage />
      <OrderTablePage />
    </div>
  );
};
